module.exports = __webpack_public_path__ + "87d992b5f680be1baf7639430f9fea9a.pdf";